import React, { Component } from "react";
import Dropzone from "react-dropzone";
import './FileDrag.css';
import { getTranslation } from '../../assets/creator/translations';
import { NavLink } from 'react-router-dom';

class Basic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      StorageFile: undefined,
      acceptedFileItems: [],
      rejectedFileItems: [],
      isFileLoaded: false
    };
  }

  onDelete = () => {
    this.setState({ acceptedFileItems: [], isFileLoaded: false });
  }

  onDropAccepted = (acceptedFileItems) => {
    const x = this;
    acceptedFileItems.forEach(file => {
      const reader = new FileReader();
     
      reader.onerror = () => {
        console.log("readerFailed");
        x.setState({ isFileLoaded: false });
      }

      reader.onload = () => {
        x.setState({ StorageFile: reader.result });
      };

      reader.onloadend = () => {
        x.setState({ isFileLoaded: true });
      };

      reader.readAsText(file);
    });

    this.setState({ acceptedFileItems });
  };

  generateRemoveBtn = (file) => {
    if (file.type === 'text/xml') {
      return <div className="container-group">
              <div className="accept-icon"></div>
              <button className="btn-removefile" onClick={this.onDelete}></button>
            </div>
    } else {
      return <div className="container-group">
              <div className="error-icon"> </div>
              <button className="btn-removefile" onClick={this.onDelete}></button>
            </div>
    }
  };

  setImportBtnState = () => {
    if (this.state.isFileLoaded && this.state.acceptedFileItems.length > 0) {
      return "btn-import";
    } else {
      return "btn-import btn-disabled"
    }
  };

  setOnClickImportBtnAction = () => {
    if (this.state.isFileLoaded && this.state.acceptedFileItems.length > 0) {
      return () => this.props.onSelect(this.state.StorageFile, this.props.onClick);
    } else {
      return null;
    }
  };

  renderMsgContainer = (open) => {
    if (this.state.acceptedFileItems.length !== 0) {
      if (this.state.isFileLoaded) {
        return  <div className="MsgContainer__MsgDragDrop">{getTranslation("Msg_DragFile")}
                  <button className="importXml" onClick={open}>
                    {getTranslation("Btn_ChooseFile")}
                  </button>
                  <div className="MsgContainer__OnlyXml">{getTranslation("Msg_OnlyXml")}</div>
                </div>
      } else {
        return  <div className="MsgContainer__MsgDragDrop">{getTranslation("Btn_WaitForLoadTemplate")}</div>
      }
    } else {
      return  <div className="MsgContainer__MsgDragDrop">{getTranslation("Msg_DragFile")}
                <button className="importXml" onClick={open}>
                  {getTranslation("Btn_ChooseFile")}
                </button>
                <div className="MsgContainer__OnlyXml">{getTranslation("Msg_OnlyXml")}</div>
              </div>
    }
  };
  
  render() {
    const acceptedFileItems = this.state.acceptedFileItems.map(file => (
      <li className="FileList__item" key={file.path}>
        <span className="templateText">{file.name}</span>
        {this.generateRemoveBtn(file)}        
      </li>
    ));
    
    return (
      <Dropzone
        removeFile={this.removeFile}
        onDropAccepted={this.onDropAccepted}
        noClick={true}
        noKeyboard={true}
        multiple={false}
      >
        {({ getRootProps, getInputProps, open, isDragActive }) => (
          <section className="drag-container">
            <div {...getRootProps({ className: `drag-container__dropzone ${isDragActive && 'drag-container__dropzone-active'}` })}>
              <aside>
                <ul className="FileList">
                  {acceptedFileItems}
                </ul>
              </aside>

              <input {...getInputProps()} 
                accept="text/xml"
              />
              <div className="MsgContainer">
                {this.renderMsgContainer(open)}
              </div>
            </div>

            <div className='drag-container__btn-group'>
              <button className='btn-cancel' onClick={this.props.onClick}>
                {getTranslation("Cancel")}
              </button>
              <NavLink className={this.setImportBtnState()} to={'/'} onClick={this.setOnClickImportBtnAction()}>
                {getTranslation("Btn_ImportXml")}
              </NavLink>
            </div>
          </section>
        )}
      </Dropzone>
    );
  }
}

export default Basic;